import React, { useState ,useEffect} from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import Rate from "../../../components/Rate";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, boxOIcon, checkCircleIcon,lockPadIcon } from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import moment from 'moment';

function CourseDetailsHeader({className,coursedetails}) {
  const [rating, setRating] = useState(coursedetails?.course.ratting);
  const [tutor, setTutor] = useState("");
  const tutorfn = (tutor) => { 
    console.log(tutor,"tutor")
    if(tutor && tutor.length < 1) {
      let listtutortring = "Admin"
      return listtutortring
    }
    let tutorlist = [];
    if(tutor && tutor.length > 0){
      tutorlist = tutor && tutor.map(lang => (
        lang.us_name
      ))
    }
    let listtutortring = tutorlist && tutorlist.toString();
    return listtutortring
  }

  useEffect(() => {
    setRating(coursedetails?.course.ratting)
  }, [coursedetails]);


  const validity = (args) => {
    console.log(Number(coursedetails?.course.cb_validity), "args")
    let course_validity
    // args = "1";
    switch (args) {
      case "0":
        course_validity = 'Unlimited Validity';
        break;
      case "1":
        course_validity = coursedetails?.course.cb_validity > 1 ? coursedetails?.course.cb_validity + ' Days' : coursedetails?.course.cb_validity + ' Day';
        course_validity = "Validity: "+course_validity 
        // echo daysToMonth($course['cb_validity']);
        break;
      case "2":
        // console.log(selectedUTCOffset,"selectedUTCOffset")
        //convertUTCDateToLocalDate(coursedetails?.course.cb_validity_date)
        // course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' : current_date_format(1, convert_to_user_time($course['cb_validity_date']), 2);
        // course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' : coursedetails?.course.cb_validity_date
        //  course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' :  
        //  new Date(new Date(coursedetails?.course.cb_validity_date).getTime() + selectedUTCOffset);
        course_validity = coursedetails?.course.cb_validity_date;
        course_validity = moment(course_validity).format('DD-MM-YYYY');

       // return coursedetails?.course.cb_validity_date;
        course_validity = "Expiring on: "+course_validity
        break;
      default:
        // course_validity = 'Lifetime';
        break;
    }
    return course_validity
  }

  const tutorHtml = (tutor) => { 
    console.log(tutor,"tutor")
   
    if(tutor && tutor.length > 0){
      var tutorlist = tutor && tutor.map(lang => (
        '<a href="teachers/view/'+lang.id+'">'+lang.us_name+'</a>'
      ))
      console.log(tutorlist,"tutorlist")
      return tutorlist
    }
   
  }

  var myRatings = coursedetails?.course.course_reviews.reviews.length;

  const round = (args) => {
    return Math.round(args)
  }

  return (
    <div className={`${className || ""} course-inner-header`} >
      <Container>
        <Row className="align-items-center">
          <Col lg={8}>
            <div className="course-description">
              <h1>{coursedetails?.course?.cb_title}</h1>
              <p className="mb-1">{coursedetails?.course?.cb_short_description}</p>
              {myRatings > 0 && coursedetails?.course?.cb_has_rating == "1" &&
              <div className="rating-wrapper d-flex align-items-center gap-1 my-3">
                 <div className="start-wrap">
                  <p className="mb-0">{round(rating)}</p>
                  <Rate
                    rating={Number(rating)}
                    count={1}
                    onRating={(rate) => setRating(rate)}
                  />
                </div>
              </div>
              }
              <div className="rating-wrapper d-block d-md-flex align-items-center gap-3 mb-3 mt-1">
                <IconDesc
                  icon={bookIcon}
                  paraDesc="Instructed by"
                  linkDesc={tutorfn(coursedetails?.course.tutors)}
                  link="#"
                  className="mb-1 mb-md-0"
                  customTutor = {tutorHtml(coursedetails?.course.tutors)}
                />
                <IconDesc
                  icon={checkCircleIcon}
                  paraDesc= {`${validity(coursedetails?.course.cb_access_validity)}`} 
                  className="mb-1 mb-md-0"
                />
                   {coursedetails?.course.cb_parallel_course_restriction &&
                    coursedetails.course.cb_parallel_course_restriction ==
                    "1" && (
                    <IconDesc
                      icon={lockPadIcon}
                      paraDesc={"Parallel Course Restricted"}
                      className="mb-1 mb-md-0"
                    />
                  )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseDetailsHeader;
